import { AutocompleteOption, useAutocomplete } from '@/common/presentation/hooks/useAutocomplete';

import { useGetCustomerTypesAutocompleteQuery } from '@/common/infrastructure/gql/generated/schema';

type CustomerType = NonNullable<
  NonNullable<NonNullable<ReturnType<typeof useGetCustomerTypesAutocompleteQuery>['data']>['customerTypes']>['items']
>[number];

export const useListCustomerTypesAutocomplete = (
  searchTerm: string = '',
  debounceMs: number = 1000,
  onCustomerTypeSelect?: (customerType: AutocompleteOption) => void,
  skip: boolean = false
) => {
  // Call the GraphQL hook at the top level (following Rules of Hooks)
  const result = useGetCustomerTypesAutocompleteQuery({
    variables: { skip: 0, search: searchTerm },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    skip
  });

  return useAutocomplete<CustomerType>({
    searchTerm,
    debounceMs,
    onSelect: onCustomerTypeSelect,
    query: () => {
      return {
        data: { items: result.data?.customerTypes?.items },
        loading: result.loading,
        error: result.error
      };
    },
    transform: (customerType) => ({
      value: customerType.id ?? 0,
      label: customerType.typeName ?? 'Unknown Customer Type'
    })
  });
};
